export default {
  // Common
  'admin.fetchFailed': 'Failed to fetch data, please try again later',
  'admin.operationFailed': 'Operation failed',
  'admin.pagination': 'Items {start} - {end} of {total}',
  'admin.delete': 'Delete',
  'admin.cancel': 'Cancel',
  'admin.update': 'Update',
  'admin.create': 'Create',
  'admin.close': 'Close',
  'admin.notLoggedIn': 'Not Logged In',

  // User management - table
  'admin.user.title': 'User Management',
  'admin.user.colUsername': 'Username',
  'admin.user.colEmail': 'Email',
  'admin.user.colRole': 'Role',
  'admin.user.colStatus': 'Status',
  'admin.user.colPermissionCount': 'Permission Count',
  'admin.user.colCreatedAt': 'Created At',
  'admin.user.colLastLogin': 'Last Login',
  'admin.user.colActions': 'Actions',

  // User management - operation results
  'admin.user.updateSuccess': 'User updated successfully',
  'admin.user.updateFailed': 'Failed to update user',
  'admin.user.createRequirePassword': 'Password is required when creating a user',
  'admin.user.createSuccess': 'User created successfully',
  'admin.user.createFailed': 'Failed to create user',
  'admin.user.deleteSuccess': 'User deleted successfully',
  'admin.user.deleteFailed': 'Failed to delete user',

  // User roles
  'admin.user.roleSuperAdmin': 'Super Admin',
  'admin.user.roleAdmin': 'Admin',
  'admin.user.roleOperator': 'Operator',
  'admin.user.roleViewer': 'Viewer',

  // User status
  'admin.user.formStatusActive': 'Active',
  'admin.user.formStatusInactive': 'Inactive',
  'admin.user.formStatusSuspended': 'Suspended',

  // User misc display
  'admin.user.permissionsCount': '{count} permissions',
  'admin.user.neverLogin': 'Never logged in',
  'admin.user.tooltipEdit': 'Edit user',
  'admin.user.tooltipDelete': 'Delete user',
  'admin.user.deleteConfirmTitle': 'Delete this user?',
  'admin.user.deleteConfirmDesc': 'After deletion, this user will no longer be able to log in. This action cannot be undone.',
  'admin.user.newUser': 'New User',
  'admin.user.editUser': 'Edit User',

  // User form labels & validation
  'admin.user.formCheckInput': 'Please check whether all required fields are filled correctly',
  'admin.user.formUsername': 'Username',
  'admin.user.formUsernameRequired': 'Please enter a username',
  'admin.user.formUsernameMin': 'Username must be at least 3 characters',
  'admin.user.formUsernamePattern': 'Username can only contain letters, numbers and underscores',
  'admin.user.formUsernamePlaceholder': 'Enter username',

  'admin.user.formEmail': 'Email',
  'admin.user.formEmailRequired': 'Please enter an email address',
  'admin.user.formEmailInvalid': 'Invalid email format',
  'admin.user.formEmailPlaceholder': 'Enter email address',

  'admin.user.formRole': 'Role',
  'admin.user.formRoleRequired': 'Please select a role',
  'admin.user.formRolePlaceholder': 'Select a role',

  'admin.user.formStatus': 'Status',
  'admin.user.formStatusRequired': 'Please select a status',
  'admin.user.formStatusPlaceholder': 'Select user status',

  'admin.user.formPassword': 'Password',
  'admin.user.formPasswordRequired': 'Please enter a password',
  'admin.user.formPasswordMin': 'Password must be at least 6 characters',
  'admin.user.formPasswordPlaceholder': 'Enter password',
  'admin.user.formResetPassword': 'Reset password',
  'admin.user.formResetPasswordHint': 'Leave blank to keep the current password; entering a value will replace the user login password',
  'admin.user.formResetPasswordPlaceholder': 'Enter a new password to reset',
  'admin.user.resetPasswordSuccess': 'User profile and password updated',

  // Role management - common & results
  'admin.role.title': 'Role Management',
  'admin.role.newRole': 'New Role',
  'admin.role.editRole': 'Edit Role',
  'admin.role.updateSuccess': 'Role updated successfully',
  'admin.role.updateFailed': 'Failed to update role',
  'admin.role.createSuccess': 'Role created successfully',
  'admin.role.createFailed': 'Failed to create role',
  'admin.role.deleteSuccess': 'Role deleted successfully',
  'admin.role.deleteFailed': 'Failed to delete role',

  // Role levels
  'admin.role.levelHighest': 'Highest',
  'admin.role.levelHigh': 'High',
  'admin.role.levelMedium': 'Medium',
  'admin.role.levelLow': 'Low',
  'admin.role.levelLabel': 'Level {level}',

  // Role table columns
  'admin.role.colName': 'Role Key',
  'admin.role.colDescription': 'Description',
  'admin.role.colLevel': 'Level',
  'admin.role.colPermissionCount': 'Permission Count',
  'admin.role.colActions': 'Actions',

  // Role table actions
  'admin.role.tooltipView': 'View details',
  'admin.role.tooltipEdit': 'Edit role',
  'admin.role.tooltipDelete': 'Delete role',
  'admin.role.deleteConfirmTitle': 'Delete this role?',
  'admin.role.deleteConfirmDesc': 'After deletion, users with this role will lose its permissions. Proceed with caution.',

  // Role form
  'admin.role.formName': 'Role Key',
  'admin.role.formNameRequired': 'Please enter a role key',
  'admin.role.formNameMin': 'Role key must be at least 2 characters',
  'admin.role.formNamePattern': 'Role key can only contain letters, numbers and underscores',
  'admin.role.formNamePlaceholder': 'e.g. operator, viewer',

  'admin.role.formDescription': 'Role Description',
  'admin.role.formDescriptionRequired': 'Please enter a role description',
  'admin.role.formDescriptionMax': 'Role description cannot exceed 200 characters',
  'admin.role.formDescriptionPlaceholder': 'Describe what this role is used for',

  'admin.role.formLevel': 'Role Level',
  'admin.role.formLevelRequired': 'Please select a role level',
  'admin.role.formLevelExtra': 'Smaller numbers indicate higher privileges, Super Admin is the highest level',
  'admin.role.formLevelPlaceholder': 'Select a role level',

  'admin.role.formPermissions': 'Permissions',
  'admin.role.formPermissionsRequired': 'Please select at least one permission',
  'admin.role.formPermissionsExtra': 'Select which system features this role can access and execute',

  // Role permission transfer component
  'admin.role.transferTitleLeft': 'Available Permissions',
  'admin.role.transferTitleRight': 'Selected Permissions',
  'admin.role.transferItemUnit': 'item',
  'admin.role.transferItemsUnit': 'items',
  'admin.role.transferSearchPlaceholder': 'Search permissions',
  'admin.role.transferNotFound': 'No matching permissions found',

  // Role detail
  'admin.role.detailTitle': 'Role Details - {name}',
  'admin.role.descName': 'Role Key',
  'admin.role.descLevel': 'Role Level',
  'admin.role.descDescription': 'Description',
  'admin.role.descPermissionCount': 'Permission Count',
  'admin.role.permissionDetails': 'Permission Details',

  // Permission management - categories
  'admin.permission.categoryDashboard': 'Dashboard',
  'admin.permission.categoryProduct': 'Product Management',
  'admin.permission.categoryOrder': 'Order Management',
  'admin.permission.categoryDear': 'DEAR Data',
  'admin.permission.categoryLog': 'Log Management',
  'admin.permission.categorySystem': 'System Management',

  // Permission management - general & results
  'admin.permission.title': 'Permission Management',
  'admin.permission.overview': 'Permission Overview',
  'admin.permission.newPermission': 'New Permission',
  'admin.permission.editPermission': 'Edit Permission',
  'admin.permission.createSuccess': 'Permission created successfully',
  'admin.permission.createFailed': 'Failed to create permission',
  'admin.permission.updateSuccess': 'Permission updated successfully',
  'admin.permission.updateFailed': 'Failed to update permission',
  'admin.permission.deleteSuccess': 'Permission deleted successfully',
  'admin.permission.deleteFailed': 'Failed to delete permission',

  // Permission management - list columns
  'admin.permission.colName': 'Name',
  'admin.permission.colId': 'Permission ID',
  'admin.permission.colCategory': 'Category',
  'admin.permission.colResource': 'Resource',
  'admin.permission.colActions': 'Actions',
  'admin.permission.colDescription': 'Description',

  // Permission management - action tooltips
  'admin.permission.tooltipView': 'View Details',
  'admin.permission.tooltipEdit': 'Edit Permission',
  'admin.permission.tooltipDelete': 'Delete Permission',
  'admin.permission.deleteConfirmTitle': 'Delete this permission?',
  'admin.permission.deleteConfirmDesc': 'All role bindings for this permission will be removed. This action cannot be undone.',

  // Permission management - form
  'admin.permission.formName': 'Name',
  'admin.permission.formNameRequired': 'Please enter permission name',
  'admin.permission.formNameMin': 'Name must be at least 2 characters',
  'admin.permission.formNamePlaceholder': 'e.g. View Product List',

  'admin.permission.formDescription': 'Description',
  'admin.permission.formDescriptionRequired': 'Please enter description',
  'admin.permission.formDescriptionMax': 'Description must be at most 200 characters',
  'admin.permission.formDescriptionPlaceholder': 'Describe what this permission grants',

  'admin.permission.formCategory': 'Category',
  'admin.permission.formCategoryRequired': 'Please select a category',
  'admin.permission.formCategoryPlaceholder': 'Select the category this permission belongs to',

  'admin.permission.formResource': 'Resource',
  'admin.permission.formResourceRequired': 'Please enter a resource',
  'admin.permission.formResourcePlaceholder': 'e.g. product, order',

  'admin.permission.formAction': 'Action',
  'admin.permission.formActionRequired': 'Please enter an action',
  'admin.permission.formActionPlaceholder': 'e.g. read, write, delete',

  // Permission management - detail
  'admin.permission.detailTitle': 'Permission Details - {name}',
  'admin.permission.descId': 'Permission ID',
  'admin.permission.descName': 'Name',
  'admin.permission.descCategory': 'Category',
  'admin.permission.descResource': 'Resource',
  'admin.permission.descAction': 'Action',
  'admin.permission.descDescription': 'Description',

  // Settings page
  'admin.settings.fetchFailed': 'Failed to load system settings, please try again later',
  'admin.settings.saveSuccess': 'Settings saved successfully',
  'admin.settings.saveFailed': 'Failed to save settings',
  'admin.settings.inputNumber': 'Please enter a valid number',
  'admin.settings.extraComma': 'Use commas to separate multiple values',
  'admin.settings.placeholderComma': 'e.g. value1,value2,value3',
  'admin.settings.extraJson': 'Please enter a valid JSON configuration',
  'admin.settings.placeholderJson': 'e.g. {"key":"value"}',
  'admin.settings.loading': 'Loading system settings...',
  'admin.settings.alertTitle': 'System Configuration',
  'admin.settings.alertDesc': 'You can view and adjust critical system settings here. Please understand the impact before modifying.',
  'admin.settings.configCount': '{count} configuration items',
  'admin.settings.view': 'View',
  'admin.settings.edit': 'Edit',
  'admin.settings.moreConfig': '{count} more configuration items',
  'admin.settings.modalTitle': '{section} Configuration Details',
  'admin.settings.modalConfigItem': '{section} Configuration',
  'admin.settings.modalConfigCount': '{count} items in total',
  'admin.settings.saveConfig': 'Save Configuration',
};
